export const lang = {
    contact:'Contact',
    name:'Baway Technology（Weifang）Co.,Ltd.',
    add:'Add',
    addInfo:'Northwest of the intersection of Jinshan Street and Weixu Road, Xin\'an Street, Anqiu City, Weifang City, Shandong Province',
    contactEr:'Contact：Mr. Song',
    Tel:'Tel',
    Mobile:'Mobile',
    Email:'Email',
    Website:'Website',
    position:'Current position',
    Baway:'Baway\'s',
    advantages:'four main advantages',
    advantages1:'Excellent brand, footprint in all walks of life',
    content1:'Baway fluid equipment is widely used in deep processing and separation and extraction of non-metallic mineral materials, cement, cuttings, abrasives, refractory materials, dyes, coatings, chemicals, metal powder, luminous materials, electronic materials, ceramics, pesticides, paper, pharmaceuticals, food, health care products and other materials.',
    advantages2:'Professional services, "one-stop" solutions',
    content2:'Weifang Baway Fluid Technology Co., Ltd. has a professional experiment center and testing center, ready to provide customers with research and development assistance, technical consulting services, and discuss with customers to solve all kinds of fluid deep processing problems, make full use of our technology and experience to provide customers with the best process and equipment design, to improve the efficiency of customers.',
    advantages3:'The choice of more than 1,500 customers worldwide',
    content3:'Weifang Baway Fluid Technology Co., Ltd. has more than 1,500 stable partners, worldwide for its comminution and separation equipment, filters, and industrial testing instruments.',
    advantages4:'Dedicated research to build your wealthy future',
    content4:'Weifang Baway Fluid Technology Co., Ltd. has a professional R&D team, focusing on the development, production, and sales of fluid equipment and high-end instrumentation. We have mastered a number of core technologies, and our products are highly praised and satisfied by customers.',
    hotline:'National service hotline',
    Company:'Company Profile',
    Foot:'Foot on the ground, carrying you and me',
    Introduction1:'Weifang Baway Fluid Technology Co., Ltd. is a joint venture subsidiary of Hong Kong Allied Planet Limited and Shanghai Baway Technology Co., Ltd.',
    Introduction2:'The R&D team specializes in communication and information systems, electrochemistry, structural design, computer science, automation, semiconductor materials, etc. All of them have many years of experience in product development, and they can not only realize product improvement, perfection, upgrade, and iteration, but also develop new products and reasonable solutions according to customer requirements.',
    Introduction3:'Since its development, we have been actively responding to the national industrial planning policies, constantly making breakthroughs in technological innovation, and taking up the responsibility to break through ourselves in the tide of technology and innovation development. Over the years, we have always insisted on science and technology innovation as the first productive force, catering to the national "14th Five-Year Plan formulation" development goals and positioning, actively adjusting the industrial layout for a rainy day, constantly adapting to the various impacts of international and domestic emerging industrial changes, and thus enhancing the core competitiveness of our company.',
    Introduction4:'Baway has been adhering to the corporate philosophy of "focus on products, strive for excellence, respect customer needs" and the spirit of innovation, and strive to make contributions to the development of China\'s fluid industry.',
    Introduction5:'We believe that quality and efficiency are reflected in the smallest details: engineering, R&D experiments, equipment production, or commissioning, at every stage of your project, we give our full attention at all times.',
    Introduction6:'Mission and Values',
    Mission:'Mission and Values',
    Mission1:'The company\'s values',
    Mission2:'Change our life with technology, highlight the quality of products with details, and achieve our business with a focus',
    Mission3:'Enterprise spirit',
    Mission4:'Service! Innovation! Win-win!',
    Mission5:'Marketing concept',
    Mission6:'Attract customers with technology! Lead customers with wisdom! Provide customers with competitive solutions!',
    Mission7:'Quality philosophy',
    Mission8:'Quality is the character!',
    Mission9:'Enterprise spirit',
    Mission10:'Entrepreneurial spirit: dare to innovate and keep improving',
    Product:'Product',
    Description:'Description',
    technical:'Parameter',
    index:'Homepage',
    Introduction:'Introduction',
    Qualification:'Qualification',
    Customized:'Customized one-stop solution',
    index1:'index',
    more:'Understand more',
    check:'check',
    Previous:'Previous',
    Next:'Next',
    Professional:'Professional product, dedicated service',
    innovation:'innovation',
    Cooperation:'Cooperation',
    win:'win-win',
    development:'Product Development',
    manufacturing:'Manufacturing',
    market:'Market Expansion',
    Support:'Support Services',
    scope:'Scope',
    Popular:'Popular',
    Assurance:'Service Commitment Quality Assurance',
    number:'Product number',
    model:'Product model',
    price:'Product price',
    picture:'picture',
    news:'news',


}

